module.exports = __webpack_public_path__ + "12_angry_men.0458b64c.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/cinema/12_angry_men.jpg
// module id = XIHG
// module chunks = 0